import { PoliticaUsuarioStatus } from '..';
import { BaseModelDto } from '../base-model/base-model.dto';

export class PoliticaUsuarioDto extends BaseModelDto {
  id: number;
  politicaId: number;
  usuarioId: number;
  status: PoliticaUsuarioStatus;
}
